
import Post from '../../components/Post';
import Input from './Input';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useEffect, useMemo, useRef, useState } from 'react';
import { AgendaPost, 
        GetAgendaUserQuery, 
        GetAgendaUserQueryVariables, 
        ModelSortDirection,
        PostByRoomQuery,
        PostByRoomQueryVariables,
        PostsByCompanyQuery, PostsByCompanyQueryVariables } from '../../graphql/API';
import { getAgendaUser, postByRoom, postsByCompany } from './queries';
import { useAuthContext } from '../../contexts/AuthContext';
import useNotificationStorageService from '../services/NotificationStorageService';
import { useNotification } from "../../contexts/NotificationProvider";
import UserImage from '../../components/UserImage';
import SubscriptionUserPostWrapper from './subscriptionWrappers/subscriptionUserPostWrapper';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { FaUsers } from 'react-icons/fa6';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { IPost } from '../../Types/models';
import Sidebar from '../services/Sidebar/Sidebar';
import { POSTS_PER_PAGE, DISPLAY_NEWS_TYPE } from '../../config';
import { useSearchParams } from 'react-router-dom';
import { IoNewspaper } from "react-icons/io5";
import { MdChat } from "react-icons/md";

const PostByUserScreen = () => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    const [locale, setLocale] = useState("en");
    // REF
    const lastScrollTopRef = useRef(0);
    // STATE
    const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);
    // NAVIGATION & PARAMS
    const location = useLocation();
    const navigate = useNavigate();
    const { id: chatterId } = useParams<{ id: string }>();
    const deletedId = location.state?.deleted;
    const [searchParams, setSearchParams] = useSearchParams();
    const displayType = searchParams.get('displayType');
    // POSTS
    const [newPosts, setNewPosts] = useState<AgendaPost[]>([]);
    const [posts, setPosts] = useState<AgendaPost[]>([]);
    const [nextToken, setNextToken] = useState('');
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const isRefreshingRef = useRef(false);
    // SUBSCRIPTION
    const [subscriptionKey, setSubscriptionKey] = useState(0);
    // NOTIFICATION
    const notificationContext = useNotification();
    const notificationCount = notificationContext?.notificationCount;
    const setNotificationCount = notificationContext?.setNotificationCount;
    const postCount = notificationContext?.postCount;
    const setPostCount = notificationContext?.setPostCount;
    const {updateNotificationModelCount} = useNotificationStorageService();
    // LINK
    const setPostLink = notificationContext?.setPostLink;

    const roomId = [AuthUserId, chatterId].sort().join("");

    const {data, loading, error, refetch} = 
        useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
            {variables: {userId: AuthUserId}});

    // const startDate = getStartDate();
    const {data: dataChatter, loading: loadingChatter, error: errorChatter, refetch: refetchChatter} = 
        useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
            {variables: {userId: chatterId}});
    
    const user = data?.getAgendaUser;
    const chatter = dataChatter?.getAgendaUser;

    const {data: dataPost, loading: loadingPost, error: errorPost, refetch: refetchPostData, 
        fetchMore: fetchMorePost} = useQuery<PostByRoomQuery, PostByRoomQueryVariables>
            (postByRoom, {variables: {
                room : roomId,
                sortDirection: ModelSortDirection.DESC, 
                filter: {
                    deleted: {ne: true},
                },
                limit: 8,//POSTS_PER_PAGE,
            }});
    
    // const [fetchData, {data: dataPost, loading: loadingPost, error: errorPost, refetch: refetchPostData, 
    //     fetchMore: fetchMorePost}] = useLazyQuery<PostsByCompanyQuery, PostsByCompanyQueryVariables >
    //         (postsByCompany);

    // const {data: dataPost, loading: loadingPost, error: errorPost, 
    //     refetch: refetchPostData, fetchMore: fetchMorePost} = 
    //     useQuery<PostsByCompanyQuery, PostsByCompanyQueryVariables >(postsByCompany
    //     ,{variables: {comId: user?.comId, sortDirection: ModelSortDirection.DESC, 
    //         limit: 15, filter: {deleted: {ne: true}}}});
    
   
    // const {data: newPostsData, loading: newPostsLoading, error: newPostError} = useSubscription<
    //     OnCreateAgendaPostByCompanyIdSubscription, 
    //     OnCreateAgendaPostByCompanyIdSubscriptionVariables>(onCreateAgendaPostByCompanyId, 
    //         {variables: {comId: user?.comId, filter : {
    //             or: [
    //                 { room: { eq: user?.userId+chatterId } },
    //                 { room: { eq: chatterId+user?.userId } }
    //             ]
    //         }}}); //{filter: {comId: {eq: user?.comId}}}});

    const scrollToBottom = (animate = true) => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'                       
        });
    };

    // 💡 Iinitial positionning for posts
    useEffect(() => {
        if (displayType != DISPLAY_NEWS_TYPE) {
            if (dataPost && posts.length > 0 && shouldScrollToBottom) {
                scrollToBottom(false);
                setShouldScrollToBottom(false);
            }
        }
    }, [dataPost, posts.length]);

    useEffect(() => {
        // New post on TOP scroll after first load
        if (displayType == DISPLAY_NEWS_TYPE) {
            setPosts((dataPost?.postByRoom?.items as AgendaPost[] || []));
            setNextToken(dataPost?.postByRoom?.nextToken || '');
        // New posts on BOTTOM scroll after first load
        } else {
            if (dataPost?.postByRoom?.items?.length > 0 && posts.length === 0) {
                setPosts((dataPost?.postByRoom?.items as AgendaPost[] || []));
                setNextToken(dataPost?.postByRoom?.nextToken || '');
                setShouldScrollToBottom(true);
            }
        }
    }, [dataPost]);

    useEffect(() => {
        if (!user || !user.comId) return;
        if (!user.language) return;
        // console.log('id', chatterId);
        setLocale(user?.language);
        refetchPostData(); // hack to get the refresh (need to modify in the futur POSSIBLY WITH useLocation)
        // fetchData({
        //     variables: {
        //         comId: user?.comId, 
        //         sortDirection: ModelSortDirection.DESC, 
        //         limit: 15,
        //         filter: {
        //             deleted: {ne: true},
        //             or: [
        //                 { room: { eq: user?.userId+chatterId } },
        //                 { room: { eq: chatterId+user?.userId } }
        //               ],
        //         }}
        //     },
        // );
    }, [user]);

    // to reload each time
    useEffect(() => {
        setNotificationCount((notificationCount ?? 0) - (postCount ?? 0));
        updateNotificationModelCount('post', 0);
        setPostCount(0);
        setPostLink && setPostLink("");
    }, [location]);

    const loadMore = async () => {
        if (!nextToken || isFetchingMore) {
            return;
        };

        setIsFetchingMore(true);

        const { data: moreData } = await fetchMorePost({
            variables: { nextToken },
            updateQuery: (previousQueryResult: any, { fetchMoreResult }: any) => {
                if (!fetchMoreResult) return previousQueryResult;

                // Met à jour l'état de posts pour y inclure les nouveaux articles
                setPosts(prevPosts => [
                ...prevPosts,
                ...fetchMoreResult.postByRoom.items,
                ]);

                setNextToken(fetchMoreResult.postByRoom.nextToken);

                return {
                    ...previousQueryResult,
                    postByRoom: {
                        ...previousQueryResult.postByRoom,
                        items: [
                            ...previousQueryResult.postByRoom.items,
                            ...fetchMoreResult.postByRoom.items,
                        ],
                        nextToken: fetchMoreResult.postByRoom.nextToken,
                    },
                };
            },
        });
        setIsFetchingMore(false);
    };

    // PAGINATION
    useEffect(() => {
        if (displayType == DISPLAY_NEWS_TYPE) {
            const handleNewsScroll = () => {
                const scrollable = document.documentElement.scrollHeight - window.innerHeight;
                const scrolled = window.scrollY;
                if (scrollable - scrolled < 5) {
                    loadMore();
                }
            };
            window.addEventListener("scroll", handleNewsScroll);
            return () => window.removeEventListener("scroll", handleNewsScroll);
        } else {
            const handleChatScroll = () => {
                const lastScrollTop = lastScrollTopRef.current;
                const currentScrollTop =  document.documentElement.scrollTop;
                const isScrollingUp = currentScrollTop - 5 < lastScrollTop;
                setTimeout( () => { // Important when the page is loading
                    const scrolled = window.scrollY;
                    if (scrolled < 20 && isScrollingUp && nextToken && !isFetchingMore) {
                        loadMore().then(() => {
                            setTimeout( () => { // Important for safari
                                document.documentElement.scrollTop = 10;
                            }, 200);
                        });
                    }
                }, 200);
            };
            window.addEventListener("scroll", handleChatScroll);
            return () => window.removeEventListener("scroll", handleChatScroll);
        }
    }, [nextToken, isFetchingMore]);

    const refreshingPosts = () => {
        setNewPosts([]);
        refetchPostData();
    };

    // REFRESH BY SCROLLING
    useEffect(() => {
        window.scrollTo(0, 5);

        const handleScrollTop = () => {
            if (window.scrollY < 3 && !isRefreshingRef.current) {
                // console.log('Refreshing posts...');
                isRefreshingRef.current = true;
                refreshingPosts();
                window.scrollTo(0, 5);

                setTimeout(() => {
                    isRefreshingRef.current = false;
                }, 2000);
            }
        };

        window.addEventListener("scroll", handleScrollTop);

        return () => {
            window.removeEventListener("scroll", handleScrollTop);
        };
    }, [loadingPost]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setNewPosts([]);
        }, 1000 * 60 * 5); // 5 minutes
        
        return () => clearTimeout(timer);
    }, [newPosts]);

    const handleSubscriptionError = () => {
        console.warn("Subscription error, retrying in 5s...");
        setTimeout(() => {
          setSubscriptionKey((prev) => prev + 1);
        }, 5000);
    };

    const mergedPosts = useMemo(() => {
        // Create a map id
        const uniquePostsMap = new Map<string, AgendaPost>();

        // Ordering posts by date
        const allPosts = [...newPosts, ...posts];

        for (const post of allPosts) {
            if (post.room === roomId && post.postId) {
                // Add post if not already there
                if (!uniquePostsMap.has(post.postId)) {
                    uniquePostsMap.set(post.postId, post);
                }
            }
        }
        return Array.from(uniquePostsMap.values());
    }, [newPosts, posts, user?.comId]);

    // Apollo
    if (loadingPost || loadingChatter) {
        return (
            <div className="spinnerContainer">
                {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
                <Spinner animation="border" role="status" className="spinner">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>   
            </div>
        )
    };

    if (errorChatter) {
        return (<>
                <h1>Error fetching the posts</h1>
                <p>{error?.message}</p>
            </>);
    };

    const isNewPost = (post: AgendaPost) => {
        if (deletedId) {
            if (newPosts.some(p => p.postId === deletedId)) {
                const updatedPosts = newPosts.filter(p => p.postId !== deletedId);
                setNewPosts(updatedPosts); // ou autre logique selon ton usage
            }
        }
        const newMessages = newPosts.some(c => c.postId == post.postId && post.room == roomId);
        
        if (displayType == DISPLAY_NEWS_TYPE) {
            if (newMessages) {
                setTimeout(() => {
                    document.documentElement.scrollTop = 10;
                }, 200);
            }
        } else {
            if (newMessages) {
                setTimeout(() => {
                    scrollToBottom();
                }, 200);
            }
        }
        return newMessages;
        // console.log(newPosts.some(c => c.postId == post.postId));
        // return newPosts.some(c => c.postId == post.postId && post.room == roomId);
    };

    // const refreshingPosts = () => {
    //     setNewPosts([]);
    //     refetchPostData();
    // };

    const goToCoWorkers = () => {
        navigate(t('link.users'));
    }

    const truncate = (str: string | undefined, maxlength: number) => {
        if (str) {
          return (str.length > maxlength) ?
          str.slice(0, maxlength - 1) + '…' : str;
        } else {
          return str;
        }
    };

    // const mergedPosts = [...newPosts.filter(post => post.room === roomId), ...posts.filter(p => !newPosts.some(n => n.postId === p.postId) && p.room === roomId)];

    // console.log('posts', dataPost?.postsByCompany?.items);
    // console.log('chatter', chatter);

    return (
        <div className="d-flex min-vh-100">
            <Sidebar user={user} />
            <div className="commentScreenContainer flex-grow-1 p-3">
                {loadingPost && (
                    <div style={{ textAlign: 'center', marginBottom: 10 }}>
                        <Spinner animation="border" size="sm" />
                        <span> {t('Refreshing...')}</span>
                    </div>
                )}
                <div className="tabs">
                    {/* <Text style={[styles.textTab, styles.selectedTab]} >Private Room</Text> */}
                    <div className="post_row">
                        <Link to={t('link.users')} className='linkPostTeammate'>
                            <FaUsers size={30} color="#CCC" />
                            <span className='textTab'>{t('worker.coworkers')}</span>
                            <IoArrowRedoCircleOutline onClick={() => ""} className="hover-icon" size={30}/>
                        </Link>
                    </div>
                    { displayType == DISPLAY_NEWS_TYPE ?
                        <a href={`/posts/${chatterId}`}>
                            <MdChat size={60} className="post-display-type-icon"/>
                        </a>
                    :
                        <a href={`/posts/${chatterId}?displayType=news`}>
                            <IoNewspaper size={60} className="post-display-type-icon"/>
                        </a>
                    }
                    <div className='chatter'>
                        <UserImage user={{...chatter, userId: chatter?.userId ?? '',
                            __typename: "AgendaUser",
                            shifts: (chatter as any)?.shifts || null,
                            shiftApps: (chatter as any)?.shiftApps || null,
                            posts: (chatter as any)?.posts || null,
                            docs: (chatter as any)?.docs || null,
                            requests: (chatter as any)?.requests || null,
                            punches: (chatter as any)?.punches || null,
                            honors: (user as any)?.honors || null
                        }} customClass="coworker_sm shadow-sm hover:shadow-md" key={"worker_" + chatter.userId} />
                        { chatter?.username &&
                            <span style={{}} >{truncate(chatter.username, 15)}</span>
                        }
                    </div>
                </div>
                { (user?.comId && user?.userId && chatterId) && (
                    <SubscriptionUserPostWrapper
                        key={subscriptionKey}
                        comId={user.comId}
                        userId={user.userId}
                        chatterId={chatterId}
                        subscriptionKey={subscriptionKey}
                        onNewPost={(post) => {
                            if (post.room == roomId) {
                                setNewPosts((prev) => [post, ...prev]);
                            }
                        }}
                        onError={handleSubscriptionError}
                    />
                )}
                {/* {mergedPosts.length === 0 && !loadingPost ? (
                    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <p>{t('post.pleaseWriteComment')}</p>
                    </div>
                ) : (
                    mergedPosts.map((item, index) =>
                    item ? (
                        <Post
                            key={item.postId || index}
                            post={{
                                ...item,
                                user: (item as any)?.user || null,
                            } as IPost}
                            // Liked={true}
                            includedDetails={true}
                            isNew={isNewPost(item)}
                            locale={locale}
                        />
                    ) : null
                    )
                )} */}
                { displayType == DISPLAY_NEWS_TYPE ? (
                    mergedPosts.length === 0 && !loadingPost ? (
                        // Affiche "Veuillez écrire un commentaire"
                        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <p>{t('post.pleaseWriteComment')}</p>
                        </div>
                    ) : (
                        // mergedPosts.map((item, index) =>
                        //     item ? (
                        //         <Post
                        //             key={item.postId || index}
                        //             post={{
                        //                 ...item,
                        //                 user: (item as any)?.user || null,
                        //             } as IPost}
                        //             includedDetails={true}
                        //             isNew={isNewPost(item)}
                        //             locale={locale}
                        //         />
                        //     ) : null
                        // )
                        mergedPosts.map((item, index) =>
                            item ? (
                                <Post
                                    key={item.postId || index}
                                    post={{
                                        ...item,
                                        user: (item as any)?.user || null,
                                    } as IPost}
                                    // Liked={true}
                                    includedDetails={true}
                                    isNew={isNewPost(item)}
                                    locale={locale}
                                />
                            ) : null
                        )
                    )
                ) : (
                    // <div // FOR NEW POSTS ON BOTTOM
                    mergedPosts.length === 0 && !loadingPost ? (
                        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <p>{t('post.pleaseWriteComment')}</p>
                        </div>
                    ) : (
                        [...mergedPosts].reverse() // reverse to have the latest at the bottom (on mergedPosts copy)
                        .map((item, index) =>
                            item ? (
                                <Post
                                    key={item.postId || index}
                                    post={{
                                        ...item,
                                        user: (item as any)?.user || null,
                                    } as IPost}
                                    // Liked={true}
                                    includedDetails={true}
                                    isNew={isNewPost(item)}
                                    locale={locale}
                                />
                            ) : null
                        )
                    )
                )}
                
                {posts.length > 0 ?
                    (user && user.comId && user.userId && posts[0].room) &&
                    <Input 
                        user={{
                            ...user,
                            shifts: (user as any)?.shifts || null,
                            shiftApps: (user as any)?.shiftApps || null,
                            posts: (user as any)?.posts || null,
                            docs: (user as any)?.docs || null,
                            requests: (user as any)?.requests || null,
                            punches: (user as any)?.punches || null,
                            honors: (user as any)?.honors || null
                        }}
                        comId={user?.comId} locale={locale} room={posts[0].room} receiverId={chatterId} />
                :
                    (user && user.comId && user.userId) &&
                        <Input 
                            user={{
                                ...user,
                                shifts: (user as any)?.shifts || null,
                                shiftApps: (user as any)?.shiftApps || null,
                                posts: (user as any)?.posts || null,
                                docs: (user as any)?.docs || null,
                                requests: (user as any)?.requests || null,
                                punches: (user as any)?.punches || null,
                                honors: (user as any)?.honors || null
                            }} 
                            comId={user?.comId} locale={locale} room={roomId} receiverId={chatterId} /> //room={user.userId+chatterId} receiverId={chatterId} />
                }
                {isFetchingMore && (
                    <div style={{ textAlign: 'center', padding: '1rem' }}>
                        <Spinner animation="border" />
                    </div>
                )}
            </div>
        </div>
        
    );
};

export default PostByUserScreen;
